module.exports = "/_next/static/images/7abd6e06e022106d5e9057ec4552d296-roxinho-scene-card-with-phone-xs@3x.jpg.webp";